module.exports = __webpack_public_path__ + "static/media/ferry.357883bb.svg";